import { Loader, NoData } from '@nile/components';
import { DisplayText, Subheading } from '@superops/ui-design-system';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import styled from 'styled-components';
import EmptyContainer from './EmptyContainer';
import EmptyContainerNewLayout from './EmptyContainerNewLayout';

const ContentDeciderContainer = (props) => {
  const { fullHeight } = props;
  const MainContent = props.mainContent;
  const LoadingContent = props.loadingContent || <Loader />;

  if (props.isLoading) {
    return <> {LoadingContent} </>;
  }
  if (props.error) {
    return (
      <div className="fx col fh actr jctr">
        <DisplayText size="medium">
          <FormattedMessage id="admin.Techniciangroup.Contentdecide.msg" />
        </DisplayText>
        <Subheading>
          <FormattedMessage id="admin.Techniciangroup.Contentdecide.text" />
        </Subheading>
      </div>
    );
  }
  if (props.hasContent || props.skipEmptyPage) {
    return (
      <div
        className={`${fullHeight ? 'full-height' : ''} main-content-decider`}
      >
        {MainContent}
      </div>
    );
  }
  if (props.emptyStateType === 'notCommon') {
    return (
      <NoDataWrapper>
        <NoData
          imageURL={props.notFoundURL}
          text={props.heading}
          description={props.description}
        />
      </NoDataWrapper>
    );
  }
  if (props.newEmptyContainer) {
    return (
      <EmptyContainerNewLayout
        notFoundURL={props.notFoundURL}
        action={props.action}
        heading={props.heading}
      />
    );
  }
  return (
    <EmptyContainer
      notFoundURL={props.notFoundURL}
      action={props.action}
      heading={props.heading}
    />
  );
};

const NoDataWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default injectIntl(ContentDeciderContainer);
